import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

import { BLOCK_HANDLE_SIZE, CONNECTION_SELECTED_COLOR } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/config/blockStyleConstants"
import { unusedHandlersAnimation } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/config/flowBlockAnimations"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	handle: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		width: BLOCK_HANDLE_SIZE,
		height: BLOCK_HANDLE_SIZE,
		borderRadius: "100%",
		border: `3px solid ${colors.yellow[400]}`,
		right: `-${BLOCK_HANDLE_SIZE / 2}px`
	},
	connected: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		borderColor: colors.getPrimaryColor()
	},
	connectionLineSelected: {
		...ColorUtil.getBackgroundAndContrastColor(CONNECTION_SELECTED_COLOR),
		borderColor: CONNECTION_SELECTED_COLOR
	},
	container: {
		position: "relative"
	},
	...unusedHandlersAnimation
})

export default useStyles
